import React from "react";

import { Title } from "emoreg/atoms/Title";
import { spaces } from "emoreg/const";
import PropTypes from "prop-types";
import styled from "styled-components";
import { ifProp } from "styled-tools";

const SidebarSectionInner = styled.div`
  ${ifProp(
    { align: "center" },
    `display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      text-align: center;`
  )};

  &:not(:last-child) {
    margin-bottom: ${spaces[24]};
  }
`;

const SidebarSection = ({ title, children, lightBackground, align }) => (
  <SidebarSectionInner align={align} lightBackground={lightBackground}>
    <Title type="h4">{title}</Title>
    {children}
  </SidebarSectionInner>
);

SidebarSection.defaultProps = {
  align: "left",
};

SidebarSection.propTypes = {
  title: PropTypes.string,
  lightBackground: PropTypes.bool,
  align: PropTypes.oneOf(["left", "center"]),
};

export default SidebarSection;
